import { useState } from "react";
// import OrangeSVG from "./orange.svg"; // Your provided SVG

interface RewardPopupProps {
  onClose: () => void;
}

export default function RewardPopup({ onClose }: RewardPopupProps) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
      { image: <img src="/PopUp/Media File.svg" alt="Media file" />,subheading:"15 days streak bonus!", text: "We couldn't do it without your presence! Check in for 15 days and receive a special 200 dot \"Thank You!\"" },
  { image: <img src="/PopUp/Media File2.svg" alt="Media file 2" />,subheading:"Receive 100 dots by sending 5 joydrops!" ,text: "You got something to say, so let's say it! People would love to hear it!" },
  ];

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
      {/* Parent Popup */}
      <div
        className="w-full max-w-[620px] max-h-[90vh] sm:max-h-[591px] bg-white rounded-[12px] p-6 sm:p-[48px] flex flex-col gap-4 sm:gap-[24px] relative overflow-y-auto"
      >
        {/* Close Button */}
        <h1
          onClick={onClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 cursor-pointer text-gray-500 font-light text-4xl sm:text-6xl leading-none"
        >
          ×
        </h1>
        {/* Orange SVG Container */}
        <div className="w-full max-w-[524px] h-auto min-h-[120px] sm:min-h-[160px] mx-auto rounded-[4px] flex items-center justify-center">
          <div className="w-full h-full">
            {slides[currentSlide].image}
          </div>
        </div>

         {/* Text for each slide */}
    <div className="text-center w-full max-w-[524px] min-h-[80px] sm:min-h-[110px] mx-auto">
     <h3 className="mx-auto inline-block px-2 py-1 rounded text-black text-base sm:text-[18px] font-semibold text-center fraunces-display">
  {slides[currentSlide].subheading}
</h3>


      <p className="mx-auto mt-2 inline-block px-2 py-1 rounded text-black text-sm sm:text-[16px] font-normal space-mono-text">
        {slides[currentSlide].text}
      </p>
    </div>

        {/* Carousel Controls */}
        <div className="flex justify-center items-center gap-2 sm:gap-4 mt-2 sm:mt-4">
          <button
            onClick={prevSlide}
            className="w-10 h-10 sm:w-[48px] sm:h-[48px] flex justify-center items-center rounded-[6px] border bg-[#1D67CD] border-[#151515] text-white text-sm sm:text-base"
          >
            ◀
          </button>
          <div className="flex gap-2">
            {slides.map((_, idx) => (
              <div
                key={idx}
                className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full ${
                  idx === currentSlide ? "bg-blue-600" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
          <button
            onClick={nextSlide}
            className="w-10 h-10 sm:w-[48px] sm:h-[48px] flex justify-center bg-[#1D67CD] items-center rounded-[6px] border border-[#151515] text-white text-sm sm:text-base"
          >
            ▶
          </button>
        </div>

        {/* Blue Button */}
        <button className="w-full max-w-[524px] h-10 sm:h-[48px] mt-auto bg-[#1D67CD] text-white rounded-[6px] border border-[#151515] text-sm sm:text-base font-medium mx-auto"
        onClick={onClose}>
          Great! Got it
        </button>
      </div>
    </div>
  );
}
